<template>
	<div class="page-container">
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span v-if="!betNotFound" class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Bilhete: {{ bet.numeroBilhete }}
				</span>
			</md-app-toolbar>
			<md-app-content style="background-color: #FDFEDF !important;">
				<md-empty-state style="color: black;"  class="no-event-found"
				md-icon="sentiment_very_dissatisfied" v-if="betNotFound"
				:md-label="msg">
				<md-button class="md-raised md-accent" v-on:click="backHome()">
					VOLTAR
				</md-button>
				</md-empty-state>
				<div class="md-layout md-gutter md-alignment-center-center" v-if="loadingBet">
					<img class="titan-logo" :src="this.loadingGif" style="width: 90px;"> 
				</div>
				<div v-if="!loadingBet && !betNotFound" class="fundo-ticket-number">
					<div class="md-layout">
						<div class="md-layout-item logo">
							<img class="titan-logo" :src="this.logo_reprint">
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
							<div class="md-layout fundo-ticket-number-even">
								<div class="md-layout-item md-size-40">Número:</div>
								<div class="md-layout-item" style="text-align: right;">{{ bet.numeroBilhete }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-odd">
								<div class="md-layout-item md-size-40">Valor Apostado:</div>
								<div class="md-layout-item" style="text-align: right;">{{ (bet.valorPago / 100).toFixed(2) }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-even">
								<div class="md-layout-item md-size-50">Possível Retorno:</div>
								<div class="md-layout-item" style="text-align: right;">{{ (bet.valorPremio / 100).toFixed(2) }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-odd">
								<div class="md-layout-item md-size-40">Eventos:</div>
								<div class="md-layout-item" style="text-align: right;">{{ bet.eventosBilhetes.length }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-even">
								<div class="md-layout-item md-size-40">Data:</div>
								<div class="md-layout-item" style="text-align: right;">{{ bet.momento }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-odd">
								<div class="md-layout-item md-size-40">Apostador:</div>
								<div class="md-layout-item" style="text-align: right;">{{ bet.nomeCliente }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-even">
								<div class="md-layout-item md-size-40">Status:</div>
								<div class="md-layout-item" style="text-align: right;" v-bind:class="verifyColorStatus(bet.nomeStatus)">{{ bet.nomeStatus }}</div>
							</div>
							<div class="md-layout">
								<div class="md-layout-item" style="text-align: center; font-weight: bold;">Apostas</div>
							</div>
							<div class="md-layout" v-for="(subevento, key) in bet.eventosBilhetes" v-bind:class="verifyOddEven(key)">
								<div class="md-layout-item" style="padding-top: 3px; padding-bottom: 3px; text-align: center;">
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.momentoEvento }}</div>
									</div>
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.nomeGrupoSecundario }}</div>
									</div>
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.tituloEvento }}</div>
									</div>
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.tituloSubEvento }}: {{ subevento.label }} - {{ subevento.cotacao/100 }}</div>
									</div>
									<div class="md-layout tempoReal" v-if="subevento.tempoReal">
										<div class="md-layout-item status-pendente-text">{{ subevento.tempoReal.placar }} ({{ subevento.tempoReal.timer }}<span v-if="subevento.tempoReal.timer != 'Encerrado'" class="blinktimer">'</span>)</div>
									</div>
									<div class="md-layout tempoReal" v-if="!(subevento.tempoReal) && subevento.timer == 'Encerrado'">
										<div class="md-layout-item status-pendente-text">{{ subevento.placar }} ({{ subevento.timer }})</div>
									</div>
									<div class="md-layout">
										<div v-if="!(subevento.tempoReal) || subevento.tempoReal.timer == 'Encerrado'" class="md-layout-item" v-bind:class="verifyColorStatus(statusSubevento(subevento))">{{ statusSubevento(subevento) }}</div>
										<div v-if="(subevento.tempoReal) && subevento.tempoReal.timer != 'Encerrado'" class="md-layout-item blinktimer" v-bind:class="verifyColorStatus(statusSubevento(subevento))">{{ statusSubevento(subevento) }}</div>
									</div>
								</div>
							</div>
							<qrcode-vue :value="id" :size="size" level="H" style="text-align: center; margin-top: 10px; margin-bottom: 10px;"></qrcode-vue>
						</div>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'
	import QrcodeVue from 'qrcode.vue';

	export default {
		name: 'TitanReprint',
		components: {
			QrcodeVue
		},
		data () {
			return {
				id: 0,
				loadingBet: true,
				betNotFound: false,
				bet: {},
				size: 150,
				logo_reprint: this.$root.$data.THEME.logo_reprint,
				loadingGif: this.$root.$data.THEME.loading_gif,
			}
		},
		created() {
				this.id = this.$route.params.id;
		},
		methods: {
			backHome: function() {
				this.$router.go(-1)
			},
			verifyOddEven: function(key) {
				return {
					'fundo-ticket-number-odd': (key % 2 == 0),
					'fundo-ticket-number-even': (key % 2 != 0)
				}
			},
			verifyColorStatus: function(status) {
				return {
					'status-pendente-text': (status == 'Aguardando Resultado'),
					'status-win-text': (status == 'Premiado' || status == 'Ganhando'),
					'status-lose-text': (status == 'Não Premiado' || status == 'Perdendo'),
					'status-canceled-text': (status == 'Cancelada'),
					'status-closed-text': (status == 'Encerrado')
				}
			},
			statusSubevento: function(subevento) {
				if (subevento.tempoReal) {
					return subevento.tempoReal.status
				}
				else {
					return subevento.nomeStatus
				}
			},
			statusBet: function(bet) {

			},
			getTicket() {
					if (this.id == 0) return false;

					var config = {
				headers: {}
			};

				axios
		.get(this.$root.$data.API_URL + 'bilhete/' + this.id, config)
		.then(response => {
			//console.log(response.data);
			if (response.status == 200) {
						this.bet = response.data
					} else {
						this.betNotFound = true
						this.msg = response.data.mensagem
					}
				})
		.finally(() => this.loadingBet = false );
				
			},
			track() {
				var t = this
				t.getTicket()
				setTimeout(function() {
					t.track()
				}, 30000);
			}
		},
		mounted() {
			this.track();
		}
	}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #000000, // The primary color of your brand
	accent: #226DA7 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme

.logo {
	text-align: center;
	margin-top: 10px;
}

</style>